import { render, staticRenderFns } from "./TranscriptViewer.vue?vue&type=template&id=9195297a&scoped=true&"
import script from "./TranscriptViewer.vue?vue&type=script&lang=ts&"
export * from "./TranscriptViewer.vue?vue&type=script&lang=ts&"
import style0 from "./TranscriptViewer.vue?vue&type=style&index=0&id=9195297a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9195297a",
  null
  
)

export default component.exports